// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles_container__fDR0y {\n    display: grid;\n    grid-auto-flow: column;\n    grid-gap: 50px;\n\n    justify-content: start;\n    align-items: center;\n}", "",{"version":3,"sources":["webpack://./src/Business/client-type-filter/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;;IAEd,sBAAsB;IACtB,mBAAmB;AACvB","sourcesContent":[".container {\n    display: grid;\n    grid-auto-flow: column;\n    grid-gap: 50px;\n\n    justify-content: start;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "styles_container__fDR0y"
};
export default ___CSS_LOADER_EXPORT___;
